import {DistanceType, RangeType, SpellRange} from '../../generated/types';
import {isSpellAreaRange} from './is-spell-area-range';
import {toSpellDistance} from './to-spell-distance';
import {toSpellDistanceFigure} from './to-spell-distance-figure';

/** Дистанция и область: «120 футов», «Касание», «На себя (15-футовый Куб)» */
export function toSpellRange(range: SpellRange) {
	if (isSpellAreaRange(range)) {
		let figure = '';
		switch (range.type) {
			case RangeType.cube:
				figure = `${toSpellDistanceFigure(range.distance!)} Куб`;
				break;
			case RangeType.cone:
				figure = `${toSpellDistanceFigure(range.distance!)} Конус`;
				break;
			case RangeType.line:
				figure = `${toSpellDistanceFigure(range.distance!, 'female')} Линия`;
				break;
			case RangeType.sphere:
				figure = `Сфера радиусом ${toSpellDistance(range.distance!)}`;
				break;
			case RangeType.radius:
				figure = `Радиус ${toSpellDistance(range.distance!)}`;
				break;
			case RangeType.hemisphere:
				figure = `Полусфера радиусом ${toSpellDistance(range.distance!)}`;
				break;
			case RangeType.emanation:
				figure = `${toSpellDistanceFigure(range.distance!, 'female')} Эманация`;
				break;
		}
		return `На себя (${figure})`;
	}
	if (range.type === RangeType.point) {
		switch (range.distance?.type) {
			case DistanceType.Feet:
			case DistanceType.Miles:
				return toSpellDistance(range.distance);
			case DistanceType.Self:
				return 'На себя';
			case DistanceType.Touch:
				return 'Касание';
			case DistanceType.Sight:
				return 'Поле зрения';
			case DistanceType.Unlimited:
				return 'не ограничена';
		}
	}
	if (range.type === RangeType.special) return 'особая';
}
